import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import { congestionStatsRetrieval } from "./api";
import RangeSliderInput from "common/RangeSliderInput";
import ActionsContext from "common/ActionsContext";
import { retrieveRange } from "common/api";
import Charts from "./CongestionCharts";
import { TileContainer } from "./utils";
import BqnContext from "common/BqnContext";
import { ClusterCongestionCharts } from "./ClusterCongestionCharts";

const SingleColumn = styled.div`
  flex: 1 1 100%;
  display: flex;
  flex-flow: column;
  width: 100%;
  
  svg .nv-y.nv-axis {
    .nv-axisMaxMin {
    display: none;
    }
  }
`;

const linesFromHours = (hours) => hours * (60 / 5);

const CongestionReport = ({hours, aggregateBqns}) => {
  const actions = useContext(ActionsContext);
  const [range, setRange] = useState();
  const [initialRange, setInitialRange] = useState();
  const [loading, setLoading] = useState(true);
  const [result, setResult] = useState(null);
  
  const { bqnId, clusterStatus } = useContext(BqnContext);
  const mode = clusterStatus?.mode;

  const doLoad = (withRange = true) => {
    // Nothing is asked while the BQN context has not loaded the BQN selected:
    // the commands would not carry its option, and their responses would be
    // those of the whole cluster. The effect runs again when it does.
    if (bqnId === undefined) {
      return;
    }

    const loadStats = () => {
      removeTooltips();
      setLoading(true);
      if (aggregateBqns === false ) {
        return null;
      }
      return congestionStatsRetrieval({
        hours,
        lines: linesFromHours(hours),
        mode,
        bqnId,
      }).then((result) => {
        setResult(result);
        setLoading(false);
      });
    }
    if (withRange) {
      setRange(undefined);
      retrieveRange(hours, mode, bqnId).then(setInitialRange).then(loadStats);
    } else {
      loadStats();
    }
  }

  function removeTooltips() {
    $(".nvtooltip").remove();
  }

  useEffect(() => {
    doLoad();
    
    return () => {
      removeTooltips();
    }
  }, [hours, mode, bqnId]);

  useEffect(() => {
    doLoad(false);

    return actions.recv("do-load", () => doLoad(false));
  }, [bqnId, aggregateBqns]);

  return (
    <SingleColumn>
      { aggregateBqns === false ? (
          <ClusterCongestionCharts range={range || initialRange} hours={hours} />
        ) : (
        <Charts
          {...result}
          range={range || initialRange}
          hours={hours}
          loading={loading}
        />
      )}
      <TileContainer className="full-width can-compress">
        {initialRange ? (
          <RangeSliderInput
            {...initialRange}
            onChange={(value) => setRange(value)}
          />
        ) : null}
      </TileContainer>
    </SingleColumn>
  );
};

export default CongestionReport;
